import React from 'react';
import CanvasJSReact from '@canvasjs/react-charts';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const Chart = () => {
    const options = {
        animationEnabled: true,
        exportEnabled: true,
        theme: "dark",
        title: {
            text: "Dental Treatment Chart "
        },
        axisY: {
            title: "Civil Dental Hospital",
        },
        data: [{
            type: "column",
            dataPoints: [
                { label: "Cosmetic Dentistry Surgery", y: 90 },
                { label: "Prosthodontics", y: 65 },
                { label: "Gum & Root Canal Treatment", y: 75 },
                { label: "General & Pediatric dentistry", y: 70 },
                { label: "Dentures Crown & Bridge", y: 60 },
                { label: "Orthodontic Braces & Dental Implants", y: 55 },
                { label: "Oral Surgical & Teeth Whitening", y: 45 },
                
            ]
        }]
    };

    return (

       

            <div className='chart2'>
                <CanvasJSChart options={options} />
            </div>

            
    );
}

export default Chart;
